import { cardRequestConstants, nameSpace } from "../constants/cardRequests.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null
};

export const getCardRequest = (state = initialState, action) => {
  switch (action.type) {
    case cardRequestConstants[`VIEW_${nameSpace}_REQUEST`]:
      return {
        ...state,
        loading: true,
        request: action.request,
        response: null
      };
    case cardRequestConstants[`VIEW_${nameSpace}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null
      };
    case cardRequestConstants[`VIEW_${nameSpace}_FAILURE`]:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };
    case cardRequestConstants[`VIEW_${nameSpace}_RESET`]:
      return {
        loading: false,
        success: false,
        request: null,
        response: null,
        error: null
      };
    default:
      return state;
  }
};
